import styled from 'styled-components';
import { Icon } from '../../../../../../components/common/icon/Icon';
import { IProductFilterOption } from '../../../../../../constants/product/productFilter.constant';

interface ProductFilterOptionProps {
  option: IProductFilterOption;
  onClick?: () => void;
}

export const ProductFilterOption = ({ option, onClick }: ProductFilterOptionProps) => {
  return (
    <Container onClick={onClick}>
      <FilterOptionText>{option.optionName}</FilterOptionText>

      <CloseIconWrapper>
        <Icon name={'CloseGrey2'} width={10} height={10} />
      </CloseIconWrapper>
    </Container>
  );
};

const Container = styled.button`
  height: 28px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 8px;
  gap: 4px;

  border-radius: var(--radius-small, 4px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const FilterOptionText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);
  text-align: center;

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */

  white-space: nowrap;
`;

const CloseIconWrapper = styled.div`
  min-width: 10px;
  min-height: 10px;

  display: flex;
  justify-content: center;
  align-items: center;
`;
